import { CardActions, styled } from "@mui/material"
import { simpleWidgetCardName, simpleWidgetCardSlots } from "@tm/themes"

export const SimpleWidgetCardActions = styled(CardActions, {
    name: simpleWidgetCardName,
    slot: simpleWidgetCardSlots.actions,
    overridesResolver: (_, styles) => styles.actions,
    shouldForwardProp: (prop) => prop !== "widgetVariant",
})({
    padding: 0,
})
